import { GlobalAlert } from '@thoughtspot/global-alert';
import { translate as t } from '@thoughtspot/i18n';
import { BannerAlertType } from '@thoughtspot/radiant-react/widgets/alert';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React, { useState } from 'react';
import { TranslationKeys } from './settings.constants';
import { SettingsEdit } from './settings-edit';
import { SettingsView } from './settings-view';
import { useChartSettings } from './use-chart-settings';
export const ChartCustomizationSettingsTab = () => {
    const [viewState, setViewState] = useState('view');
    const [isToastVisible, setIsToastVisible] = useState(false);
    const { status, values, isSaving, saveError, loadError, save, dismissSaveError, dismissLoadError, } = useChartSettings();
    const handleSave = async (next) => {
        if (!values)
            return;
        const { success } = await save({
            ...values,
            newChartsDefault: next,
        });
        if (success) {
            setViewState('view');
            setIsToastVisible(true);
        }
    };
    if (status === 'loading' || !values) {
        return (React.createElement(LoadingIndicator.Global, { hideLoader: false },
            React.createElement(React.Fragment, null)));
    }
    const bannerMessage = saveError ?? loadError;
    const dismissBanner = () => {
        if (saveError)
            dismissSaveError();
        else
            dismissLoadError();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalAlert.Banner, { isVisible: !!bannerMessage, message: bannerMessage ?? '', type: BannerAlertType.ERROR, onClose: dismissBanner }),
        React.createElement(GlobalAlert.Toast, { isVisible: isToastVisible, message: t(TranslationKeys.SAVE_SUCCESS_MESSAGE), onClose: () => setIsToastVisible(false), autoHide: true }),
        viewState === 'view' ? (React.createElement(SettingsView, { enabled: values.newChartsDefault, onEdit: () => setViewState('edit') })) : (React.createElement(SettingsEdit, { enabled: values.newChartsDefault, saving: isSaving, onSave: handleSave, onCancel: () => setViewState('view') }))));
};
//# sourceMappingURL=settings.container.js.map